export default __webpack_public_path__ + "static/media/centralforsedi.5986af41.svg";